import { useEffect } from 'react';
import Error from '../components/ErrorBoundary';
import getBaseCdnUrl from '../utils/getBaseCdnUrl';
import { Link } from 'react-router';

const PrivacyPolicy = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${getBaseCdnUrl()}/privacypolicy.js`;
    script.async = true;

    document.body.appendChild(script);
    document.documentElement.classList.add('bg-white');

    return () => {
      // Clean up the script when component unmounts
      document.body.removeChild(script);
      document.documentElement.classList.remove('bg-white');
    };
  }, []);

  return (
    <>
      <title>Privacy Policy</title>

      <div className="container-fluid but-fixed py-md-3 py-lg-4">
        <div className="row justify-content-center">
          <div className="col-12 d-none d-lg-block">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb text-muted">
                <li className="breadcrumb-item">
                  <Link className="text-reset" to="/">
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item active fw-600 " aria-current="page">
                  Privacy Policy
                </li>
              </ol>
            </nav>
          </div>

          <article className="col-12 col-lg-9 my-3">
            <h1>Privacy Policy</h1>
            <div id="asc_privacy_policy"></div>
          </article>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;

export const ErrorBoundary = () => {
  return <Error fromPage="Privacy Policy" />;
};
